import {
    Button,
    Typography
}                                from "@mui/material";
import {
    useEffect,
    useRef
}                                from "react";
import {
    AddLegalEntityMeasurementCommand,
    LegalEntityMeasurementDetail,
    LegalEntityMeasurements,
    UpdateLegalEntityMeasurementCommand
}                       from "../constants";
import {useGBESContext} from "../context/GBESContextProvider";
import {submitObject}   from "../util";

const LegalEntityMeasurementForm = () =>
{
    const FormRef = useRef<any>()
    const {companyDetails,energyDetails, setModalVisible,setRefreshResource,formData,
        setAlertText, setAlertVisible} = useGBESContext()

    useEffect(() =>
    {
        if (FormRef.current !== undefined && energyDetails !== undefined)
        {
            FormRef.current.data = {
                energySystemId: energyDetails.id ,
                ...formData,
            }

        }
    }, []);

    async function HandleSubmit(event: any)
    {

        //In case of a status that isnt 200, we most likely have received an error message.
        //So we display this as alert in the Modal
        if (event.status === 200)
        {
            //If everything went okay we can close it
            setModalVisible(false)
            setAlertVisible(false)
        }
        else
        {
            let response = await event.json()
            setAlertVisible(true)
            setAlertText(response.messages.reduceRight((acum: any, current: any) => acum.concat(current)))
        }

    }

    function onClickSubmit()
    {
        let Data: any = {}
        // @ts-ignore
        FormRef.current.getData().then((event: any) => Data = event)
        // @ts-ignore
        FormRef.current.submitForm().then(() =>
            {
                if (formData === undefined)
                {
                    submitObject(Data, companyDetails.id, AddLegalEntityMeasurementCommand).then(async (event: any) =>
                    {
                        HandleSubmit(event)
                    })
                    setRefreshResource(LegalEntityMeasurements)

                }
                else
                {
                    submitObject(Data, companyDetails.id, UpdateLegalEntityMeasurementCommand).then(async (event: any) =>
                    {
                        HandleSubmit(event)
                    })
                    setRefreshResource(LegalEntityMeasurementDetail)

                }
            }
        )

    }

    return (<>

        <Typography id="modal-modal-title" variant="h6" component="h2">
            {formData === undefined
             ? "Legale Entiteit Meting uitvoeren"
             : "Legale Entiteit Meting bewerken"}
        </Typography>
        {/*// @ts-ignore*/}
        <ig-form ref={FormRef} class={"rotate-form"} form-id="ONT_AddLegalEntityMeasurement"/>
        <Button variant="contained" onClick={onClickSubmit}>Submit</Button>
    </>)
}
export default LegalEntityMeasurementForm